import { FC, useEffect, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { WhatsAppCountry } from '@api/types/whatsappNumber';
import { Analytics, AnalyticsShare } from '@components/analytics/analytics';
import { tw } from '@utils/tailwind-utils';
import { getCountryNumber } from '@utils/whatsappNumber';
import { useTranslation } from 'next-i18next';

import Button from './Button';

type WhatsappLinkProps = {
  classNames?: string;
  buttonClassName?: string;
  iconClassName?: string;
  text?: string;
  whatsappCountry: WhatsAppCountry;
  onRetrieveText?: () => string;
};
const WhatsappLink: FC<WhatsappLinkProps> = ({
  classNames,
  buttonClassName,
  iconClassName,
  text,
  whatsappCountry,
  onRetrieveText
}) => {
  const phoneNumber = getCountryNumber(whatsappCountry);

  const { t } = useTranslation('share');
  const [whatsappLink, setWhastappLink] = useState<string>(
    `https://wa.me/${phoneNumber}?text=${text ? text : t('whatsapp.short')}`
  );
  useEffect(() => {
    if (onRetrieveText) {
      setWhastappLink(`https://wa.me/${phoneNumber}?text=${onRetrieveText()}`);
    }
  }, [onRetrieveText, phoneNumber]);

  const handleClick = () => {
    Analytics.event(AnalyticsShare.WEB_WHATSAPP_BUTTON, {
      whatsappLink
    });
  };

  return (
    <div className={tw('fixed bottom-0 right-0 z-20 p-6 delay-150', classNames)}>
      <a href={whatsappLink} target="_blank" rel="noopener noreferrer" id="whatsapp-support-button">
        <Button
          onClick={handleClick}
          className={`rounded-full border-[1px] bg-rentennials-primary p-4 transition delay-150 duration-300 ease-in-out  hover:-translate-y-1 hover:scale-110  lg:border-0 ${buttonClassName}`}
          style={{ animation: 'fadeIn 2s' }}
          btnName="whatsapp-button"
        >
          <FaWhatsapp className={`h-10 w-10 text-white ${iconClassName}`} />
        </Button>
      </a>
    </div>
  );
};

export default WhatsappLink;
